import { TasklistService } from '@/api/tasklist';
import TableRequest from '@/components/request/TableRequest';
import { Outlet, useSearchParams } from 'react-router-dom';

export default function RequestActive() {
  // get params ?processKey from url using react-router-dom
  const [searchParams] = useSearchParams();
  const processKey = searchParams.get('processKey');
  const page = searchParams.get('page') ?? '0';

  const { data: activeRequests, isLoading } = TasklistService.useGetMyRequest({
    processKey: processKey ?? '',
    page: page ?? '0',
  });

  return (
    <section className="bg-white rounded">
      <TableRequest
        type="active"
        title="Active Requests List"
        page={page}
        processKey={processKey ?? ''}
        isLoading={isLoading}
        data={activeRequests ?? []}
      />
      <Outlet />
    </section>
  );
}
